import Button from "@mui/material/Button";
import Dialog from "components/NoScrollDialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import LoadingButton from "components/LoadingButton";
import * as React from "react";
import usersService from "services/users-service";
import { useAuth } from "contexts/auth.context";
import MDTypography from "components/MDTypography";

import OtpInput from "react-otp-input";
import MDInput from "components/MDInput";
import { Box } from "@mui/material";
import { useLanguage } from "contexts/language.context";

export default function OTPDialog({
  isOpen,
  setOtpDialogInfo,
  email,
  password,
}) {
  const authContext = useAuth();

  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [otp, setOtp] = React.useState("");
  const [error, setError] = React.useState(null);
  const [errorOTP, setErrorOTP] = React.useState(false);
  const { label } = useLanguage();

  React.useEffect(() => {
    if (!isOpen) return;
    setOpen(true);
    setOtp("");
    setLoading(false);
    setError(false);
    setErrorOTP(false);
  }, [isOpen]);

  const handleClose = () => {
    setOtpDialogInfo(false);
    setOpen(false);
    setError(false);
    setErrorOTP(false);
  };

  async function handleVerifyOTP(otp) {
    try {
      const [response, data] = await usersService.verifyOTP(null, {
        otp: otp,
        email: email,
        password: password,
      });
      if (response.ok) {
        if (data.token_type === "Bearer") {
          authContext.login(data.access_token, data.refresh_token);
        }
      } else {
        setErrorOTP(true);
      }
    } catch (error) {
      console.log("error while verifying otp", error);
    }
  }

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
      }}
      onSubmit={async (e) => {
        e.preventDefault();
        if (otp.trim() === "") {
          setError(true);
          return;
        }
        setLoading(true);
        await handleVerifyOTP(otp);
        setLoading(false);
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, pb: 0.4, pt: 1.4 }}>
        {label("verify-otp-button")}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} mt={0.5}>
          <Grid item xs={12}>
            <OtpInput
              shouldAutoFocus
              value={otp}
              numInputs={6}
              onChange={(value) => {
                setOtp(value);
              }}
              inputStyle={{
                flex: 1,
                minHeight: "80px",
                textAlign: "center",
                fontSize: "32px",
                borderRadius: "8px",
                border: "1px solid rgba(0, 0, 0, 0.15)",
                fontFamily: "Roboto",
              }}
              renderSeparator={<Box sx={{ width: "10px" }} />}
              renderInput={(props) => <input {...props} />}
            />

            {/* <TextField
              autoFocus
              required
              error={error}
              helperText="Please enter an OTP to verify"
              id="otp_field_id_login"
              name="otp_field_name_login"
              label="OTP"
              type="text"
              value={otp}
              onChange={(event) => setOtp(event.target.value)}
              fullWidth
            />*/}
          </Grid>
          {errorOTP && (
            <Grid item xs={12}>
              <MDTypography variant="button" fontWeight="regular" color="error">
                {label("invalid-otp")}
              </MDTypography>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button type="button" onClick={handleClose} disabled={loading}>
          {label("cancel-button")}
        </Button>
        <LoadingButton
          loading={loading}
          type="submit"
          variant="gradient"
          color="info"
        >
          {label("verify-button")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
